/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * ChatAgent.Api
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  UpdateStorePreferencesCommand
} from '.././model';

import { customInstance } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getApiWorkspacesWorkspaceIdStores = (
    workspaceId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}/stores`, method: 'GET', signal
    },
      options);
    }
  



export const getGetApiWorkspacesWorkspaceIdStoresQueryKey = (workspaceId?: string,) => {
    return [
    `/api/workspaces/${workspaceId}/stores`
    ] as const;
    }

    
export const getGetApiWorkspacesWorkspaceIdStoresQueryOptions = <TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStores>>, TError = unknown>(workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStores>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWorkspacesWorkspaceIdStoresQueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStores>>> = ({ signal }) => getApiWorkspacesWorkspaceIdStores(workspaceId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStores>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiWorkspacesWorkspaceIdStoresQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStores>>>
export type GetApiWorkspacesWorkspaceIdStoresQueryError = unknown


export function useGetApiWorkspacesWorkspaceIdStores<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStores>>, TError = unknown>(
 workspaceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStores>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStores>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStores>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWorkspacesWorkspaceIdStores<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStores>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStores>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStores>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStores>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWorkspacesWorkspaceIdStores<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStores>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStores>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetApiWorkspacesWorkspaceIdStores<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStores>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStores>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiWorkspacesWorkspaceIdStoresQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiWorkspacesWorkspaceIdStoresStoreIdPreferences = (
    workspaceId: string,
    storeId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}/stores/${storeId}/preferences`, method: 'GET', signal
    },
      options);
    }
  



export const getGetApiWorkspacesWorkspaceIdStoresStoreIdPreferencesQueryKey = (workspaceId?: string,
    storeId?: string,) => {
    return [
    `/api/workspaces/${workspaceId}/stores/${storeId}/preferences`
    ] as const;
    }

    
export const getGetApiWorkspacesWorkspaceIdStoresStoreIdPreferencesQueryOptions = <TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdPreferences>>, TError = unknown>(workspaceId: string,
    storeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdPreferences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWorkspacesWorkspaceIdStoresStoreIdPreferencesQueryKey(workspaceId,storeId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdPreferences>>> = ({ signal }) => getApiWorkspacesWorkspaceIdStoresStoreIdPreferences(workspaceId,storeId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId && storeId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdPreferences>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiWorkspacesWorkspaceIdStoresStoreIdPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdPreferences>>>
export type GetApiWorkspacesWorkspaceIdStoresStoreIdPreferencesQueryError = unknown


export function useGetApiWorkspacesWorkspaceIdStoresStoreIdPreferences<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdPreferences>>, TError = unknown>(
 workspaceId: string,
    storeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdPreferences>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdPreferences>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdPreferences>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWorkspacesWorkspaceIdStoresStoreIdPreferences<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdPreferences>>, TError = unknown>(
 workspaceId: string,
    storeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdPreferences>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdPreferences>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdPreferences>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWorkspacesWorkspaceIdStoresStoreIdPreferences<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdPreferences>>, TError = unknown>(
 workspaceId: string,
    storeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdPreferences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetApiWorkspacesWorkspaceIdStoresStoreIdPreferences<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdPreferences>>, TError = unknown>(
 workspaceId: string,
    storeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdPreferences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiWorkspacesWorkspaceIdStoresStoreIdPreferencesQueryOptions(workspaceId,storeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const putApiWorkspacesWorkspaceIdStoresStoreIdPreferences = (
    workspaceId: string,
    storeId: string,
    updateStorePreferencesCommand: UpdateStorePreferencesCommand,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}/stores/${storeId}/preferences`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateStorePreferencesCommand
    },
      options);
    }
  


export const getPutApiWorkspacesWorkspaceIdStoresStoreIdPreferencesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiWorkspacesWorkspaceIdStoresStoreIdPreferences>>, TError,{workspaceId: string;storeId: string;data: UpdateStorePreferencesCommand}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putApiWorkspacesWorkspaceIdStoresStoreIdPreferences>>, TError,{workspaceId: string;storeId: string;data: UpdateStorePreferencesCommand}, TContext> => {

const mutationKey = ['putApiWorkspacesWorkspaceIdStoresStoreIdPreferences'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiWorkspacesWorkspaceIdStoresStoreIdPreferences>>, {workspaceId: string;storeId: string;data: UpdateStorePreferencesCommand}> = (props) => {
          const {workspaceId,storeId,data} = props ?? {};

          return  putApiWorkspacesWorkspaceIdStoresStoreIdPreferences(workspaceId,storeId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiWorkspacesWorkspaceIdStoresStoreIdPreferencesMutationResult = NonNullable<Awaited<ReturnType<typeof putApiWorkspacesWorkspaceIdStoresStoreIdPreferences>>>
    export type PutApiWorkspacesWorkspaceIdStoresStoreIdPreferencesMutationBody = UpdateStorePreferencesCommand
    export type PutApiWorkspacesWorkspaceIdStoresStoreIdPreferencesMutationError = unknown

    export const usePutApiWorkspacesWorkspaceIdStoresStoreIdPreferences = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiWorkspacesWorkspaceIdStoresStoreIdPreferences>>, TError,{workspaceId: string;storeId: string;data: UpdateStorePreferencesCommand}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiWorkspacesWorkspaceIdStoresStoreIdPreferences>>,
        TError,
        {workspaceId: string;storeId: string;data: UpdateStorePreferencesCommand},
        TContext
      > => {

      const mutationOptions = getPutApiWorkspacesWorkspaceIdStoresStoreIdPreferencesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const patchApiWorkspacesWorkspaceIdStoresStoreIdPreferences = (
    workspaceId: string,
    storeId: string,
    updateStorePreferencesCommand: UpdateStorePreferencesCommand,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}/stores/${storeId}/preferences`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateStorePreferencesCommand
    },
      options);
    }
  


export const getPatchApiWorkspacesWorkspaceIdStoresStoreIdPreferencesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiWorkspacesWorkspaceIdStoresStoreIdPreferences>>, TError,{workspaceId: string;storeId: string;data: UpdateStorePreferencesCommand}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchApiWorkspacesWorkspaceIdStoresStoreIdPreferences>>, TError,{workspaceId: string;storeId: string;data: UpdateStorePreferencesCommand}, TContext> => {

const mutationKey = ['patchApiWorkspacesWorkspaceIdStoresStoreIdPreferences'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiWorkspacesWorkspaceIdStoresStoreIdPreferences>>, {workspaceId: string;storeId: string;data: UpdateStorePreferencesCommand}> = (props) => {
          const {workspaceId,storeId,data} = props ?? {};

          return  patchApiWorkspacesWorkspaceIdStoresStoreIdPreferences(workspaceId,storeId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchApiWorkspacesWorkspaceIdStoresStoreIdPreferencesMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiWorkspacesWorkspaceIdStoresStoreIdPreferences>>>
    export type PatchApiWorkspacesWorkspaceIdStoresStoreIdPreferencesMutationBody = UpdateStorePreferencesCommand
    export type PatchApiWorkspacesWorkspaceIdStoresStoreIdPreferencesMutationError = unknown

    export const usePatchApiWorkspacesWorkspaceIdStoresStoreIdPreferences = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiWorkspacesWorkspaceIdStoresStoreIdPreferences>>, TError,{workspaceId: string;storeId: string;data: UpdateStorePreferencesCommand}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiWorkspacesWorkspaceIdStoresStoreIdPreferences>>,
        TError,
        {workspaceId: string;storeId: string;data: UpdateStorePreferencesCommand},
        TContext
      > => {

      const mutationOptions = getPatchApiWorkspacesWorkspaceIdStoresStoreIdPreferencesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getApiStoresStoreIdPreferences = (
    storeId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/stores/${storeId}/preferences`, method: 'GET', signal
    },
      options);
    }
  



export const getGetApiStoresStoreIdPreferencesQueryKey = (storeId?: string,) => {
    return [
    `/api/stores/${storeId}/preferences`
    ] as const;
    }

    
export const getGetApiStoresStoreIdPreferencesQueryOptions = <TData = Awaited<ReturnType<typeof getApiStoresStoreIdPreferences>>, TError = unknown>(storeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStoresStoreIdPreferences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStoresStoreIdPreferencesQueryKey(storeId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStoresStoreIdPreferences>>> = ({ signal }) => getApiStoresStoreIdPreferences(storeId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(storeId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStoresStoreIdPreferences>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiStoresStoreIdPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStoresStoreIdPreferences>>>
export type GetApiStoresStoreIdPreferencesQueryError = unknown


export function useGetApiStoresStoreIdPreferences<TData = Awaited<ReturnType<typeof getApiStoresStoreIdPreferences>>, TError = unknown>(
 storeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStoresStoreIdPreferences>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiStoresStoreIdPreferences>>,
          TError,
          Awaited<ReturnType<typeof getApiStoresStoreIdPreferences>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiStoresStoreIdPreferences<TData = Awaited<ReturnType<typeof getApiStoresStoreIdPreferences>>, TError = unknown>(
 storeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStoresStoreIdPreferences>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiStoresStoreIdPreferences>>,
          TError,
          Awaited<ReturnType<typeof getApiStoresStoreIdPreferences>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiStoresStoreIdPreferences<TData = Awaited<ReturnType<typeof getApiStoresStoreIdPreferences>>, TError = unknown>(
 storeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStoresStoreIdPreferences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetApiStoresStoreIdPreferences<TData = Awaited<ReturnType<typeof getApiStoresStoreIdPreferences>>, TError = unknown>(
 storeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStoresStoreIdPreferences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiStoresStoreIdPreferencesQueryOptions(storeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiWorkspacesWorkspaceIdStoresStoreIdSandboxToken = (
    workspaceId: string,
    storeId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}/stores/${storeId}/sandbox-token`, method: 'GET', signal
    },
      options);
    }
  



export const getGetApiWorkspacesWorkspaceIdStoresStoreIdSandboxTokenQueryKey = (workspaceId?: string,
    storeId?: string,) => {
    return [
    `/api/workspaces/${workspaceId}/stores/${storeId}/sandbox-token`
    ] as const;
    }

    
export const getGetApiWorkspacesWorkspaceIdStoresStoreIdSandboxTokenQueryOptions = <TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdSandboxToken>>, TError = unknown>(workspaceId: string,
    storeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdSandboxToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWorkspacesWorkspaceIdStoresStoreIdSandboxTokenQueryKey(workspaceId,storeId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdSandboxToken>>> = ({ signal }) => getApiWorkspacesWorkspaceIdStoresStoreIdSandboxToken(workspaceId,storeId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId && storeId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdSandboxToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiWorkspacesWorkspaceIdStoresStoreIdSandboxTokenQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdSandboxToken>>>
export type GetApiWorkspacesWorkspaceIdStoresStoreIdSandboxTokenQueryError = unknown


export function useGetApiWorkspacesWorkspaceIdStoresStoreIdSandboxToken<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdSandboxToken>>, TError = unknown>(
 workspaceId: string,
    storeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdSandboxToken>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdSandboxToken>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdSandboxToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWorkspacesWorkspaceIdStoresStoreIdSandboxToken<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdSandboxToken>>, TError = unknown>(
 workspaceId: string,
    storeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdSandboxToken>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdSandboxToken>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdSandboxToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWorkspacesWorkspaceIdStoresStoreIdSandboxToken<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdSandboxToken>>, TError = unknown>(
 workspaceId: string,
    storeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdSandboxToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetApiWorkspacesWorkspaceIdStoresStoreIdSandboxToken<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdSandboxToken>>, TError = unknown>(
 workspaceId: string,
    storeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdStoresStoreIdSandboxToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiWorkspacesWorkspaceIdStoresStoreIdSandboxTokenQueryOptions(workspaceId,storeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const deleteApiWorkspacesWorkspaceIdStoresStoreId = (
    workspaceId: string,
    storeId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}/stores/${storeId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteApiWorkspacesWorkspaceIdStoresStoreIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiWorkspacesWorkspaceIdStoresStoreId>>, TError,{workspaceId: string;storeId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiWorkspacesWorkspaceIdStoresStoreId>>, TError,{workspaceId: string;storeId: string}, TContext> => {

const mutationKey = ['deleteApiWorkspacesWorkspaceIdStoresStoreId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiWorkspacesWorkspaceIdStoresStoreId>>, {workspaceId: string;storeId: string}> = (props) => {
          const {workspaceId,storeId} = props ?? {};

          return  deleteApiWorkspacesWorkspaceIdStoresStoreId(workspaceId,storeId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiWorkspacesWorkspaceIdStoresStoreIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiWorkspacesWorkspaceIdStoresStoreId>>>
    
    export type DeleteApiWorkspacesWorkspaceIdStoresStoreIdMutationError = unknown

    export const useDeleteApiWorkspacesWorkspaceIdStoresStoreId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiWorkspacesWorkspaceIdStoresStoreId>>, TError,{workspaceId: string;storeId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiWorkspacesWorkspaceIdStoresStoreId>>,
        TError,
        {workspaceId: string;storeId: string},
        TContext
      > => {

      const mutationOptions = getDeleteApiWorkspacesWorkspaceIdStoresStoreIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    